import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';
interface CompletedProps {
  color?: string;
  altColor?: string;
  style?: React.CSSProperties;
}

export const TimeClockIcon = ({
  color = RoutalPalette.neutral00,
  altColor = RoutalPalette.secondary40,
  style = {},
  ...props
}: CompletedProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 13 13" style={{ width: `13px`, height: `13px`, ...style }}>
      <g>
        <path
          d="M6.77762 11.7408C9.61794 11.7408 11.9205 9.43826 11.9205 6.59793C11.9205 3.75761 9.61794 1.45508 6.77762 1.45508C3.9373 1.45508 1.63477 3.75761 1.63477 6.59793C1.63477 9.43826 3.9373 11.7408 6.77762 11.7408Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.77734 3.51172V6.59743L8.83449 7.626"
          stroke={altColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
